'use client'
import LogoTeach from '@/assets/logo/teach-logo.svg'

export function Logo() {
  return <LogoTeach style={{ display: 'block', height: 24 }} />
}
